export const lngOptions = [
  { value: 'E', label: 'E' },
  { value: 'W', label: 'W' },
];

export const latOptions = [
  { value: 'N', label: 'N' },
  { value: 'S', label: 'S' },
];
